import { configureStore } from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import { logger } from "redux-logger";
import rootReducer from "../reducers/root.reducer";

const persistConfig = {
  key: 'Rocky_dashboard',
  storage,
  blacklist: ['RiderReducer','ZoneReducer',
    'BatchReducer','ShiftReducer',
    'WalletIssueReducer', 'OrderManagementReducer',
    'OrderManagementNewReducer',
    'OrderManagementListingReducer',
    'DashboardReducer',
    'DispactherNoteReducer',
    'BreakReducer',
    'CancellationReasonReducer',
    'PerformanceReducer',
    'NotificationReducer',
    'IssuesReducer',
    'CancelledOrderReducer',
    'PickerPakerPageReducer',
    'MartHealthDashboardReducer',
    'TriggersReducer',
    'UnRegisterRiderReducer',
    'TaskInvoiceReducer',
    'WorkReducer',
  ]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.REACT_APP_ENV !== 'production',
  middleware: [thunk]
  // middleware: [thunk, logger] //disable logger
})

export const persistor = persistStore(store)